/** Internal dependencies */
import { replaceContent } from "./frontendhbs/replaceContent";
import { loadAjax } from "./frontendhbs/loadAjax";
import { loadHbstmpl } from "./frontendhbs/loadHbstmpl";
import { apiCall } from "./frontendhbs/apiCall";

if (document.readyState !== "loading") {
  initRest();
} else {
  window.addEventListener("DOMContentLoaded", () => {
    initRest();
  });
}

function initRest() {
  // dynamic ajax content replacer
  const restCallsReplace = document.querySelectorAll("[data-rest-replace]");
  if (restCallsReplace) {
    restCallsReplace.forEach((parent) => replaceContent(parent));
  }

  // rest ajax loader
  const restCalls = document.querySelectorAll("[data-rest]");
  if (restCalls) {
    restCalls.forEach((parent) => loadAjax(parent));
  }

  // handlebars template
  const tmpl = document.querySelectorAll(".hbstmpl");
  if (tmpl) {
    tmpl.forEach((element) => loadHbstmpl(element));
  }
}

window.filterParent = function (parentObject) {
  if (parentObject) {
    var parent = parentObject[0];
    var filters = [];
    var apiFilter = "";

    parentObject.find("[class*='filter-']").each(function () {
      var el = jQuery(this);
      var filterName = "";
      var classes = el[0].className.split(" ");
      var prefix = "filter-";
      for (var i = classes.length; i-- > 0; ) {
        if (classes[i].substring(0, prefix.length) == prefix) {
          filterName = classes[i].substring(prefix.length);
        }
      }

      var filterValue = "";
      if (filterName !== "") {
        if (el.is(":radio")) {
          if (el.is(":checked")) {
            var filterValue = el.val();
          }
        } else {
          var filterValue = el.val();
          if (Array.isArray(filterValue)) {
            filterValue = filterValue.join("|");
          }
        }
      }

      if (filterValue != "") {
        filters.push(
          encodeURIComponent(filterName) + "=" + encodeURIComponent(filterValue)
        );
      }
    });

    if (filters.length !== 0) {
      apiFilter = filters.join("&");
    }
    apiCall(parent, apiFilter, true);
  }
};

window.filterForm = function (filterClass) {
  var filterContainer = jQuery("." + filterClass);
  var parent = filterContainer.closest("[data-rest]");

  window.filterParent(parent);
};

jQuery(document).ready(function ($) {
  $(document).on("wsf-rendered", function (e, form, form_id, instance_id) {
    $('.wsf-form[data-id="' + form_id + '"] .filter-refresh').on(
      "change",
      function () {
        if ($(this).is(":checked")) {
          var parent = $(this).closest("[data-rest]");
          window.filterParent(parent);
        }
      }
    );
  });
});
